// @flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import FileDropzone from 'common/components/core/dropzone/FileDropzone';
import FileUploadProgressAndErrors from 'common/components/core/dropzone/FileUploadProgressAndErrors';
import { translate } from 'react-i18next';

import theme from './FileDropzoneWithProgress.scss';

class FileDropzoneWithProgress extends React.PureComponent {
    getStatusText = () => {
        const { isUploadInProgress, t } = this.props;
        if (isUploadInProgress) {
            return t('uploading');
        }
        return t('uploadComplete');
    };
    render() {
        const {
            theme,
            isUploadInProgress,
            isUploadFailed,
            accept,
            fileName,
            uploadErrors,
            onCancel,
            parse,
            onFileUploadStart,
            onFileUploadSuccess,
            onFileUploadError,
            isUploadSuccessful,
            onGetTemplateClick,
            transformHeader,
            onDrop,
            actions
        } = this.props;
        return !isUploadInProgress && !isUploadFailed && !isUploadSuccessful ? (
            <FileDropzone
                accept={accept}
                theme={theme}
                parse={parse}
                isUploadInProgress={isUploadInProgress}
                onFileUploadStart={onFileUploadStart}
                onFileUploadSuccess={onFileUploadSuccess}
                onFileUploadError={onFileUploadError}
                onGetTemplateClick={onGetTemplateClick}
                transformHeader={transformHeader}
                onDrop={onDrop}
                actions={actions}
            />
        ) : (
            <FileUploadProgressAndErrors
                theme={theme}
                isUploadInProgress={isUploadInProgress}
                fileName={fileName}
                statusText={this.getStatusText()}
                uploadErrors={uploadErrors}
                success={isUploadSuccessful}
                fail={isUploadFailed}
                onCancel={onCancel}
            />
        );
    }
}

const ThemedFileDropzoneWithProgress = translate()(
    themr('FileDropzoneWithProgress', theme)(FileDropzoneWithProgress)
);
export { ThemedFileDropzoneWithProgress as FileDropzoneWithProgress };
export default ThemedFileDropzoneWithProgress;
